export const steps = [
  {
    title: "MAKE AN APPOINTMENT",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin pulvinar odio in magna condimentum, et euismod ante rhoncus. Maecenas elementum metus quis dolor convallis convallis.",
  },
  {
    title: "SELECT SERVICE",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin pulvinar odio in magna condimentum, et euismod ante rhoncus. Maecenas elementum metus quis dolor convallis convallis.",
  },
  {
    title: "CONFIRM REQUEST",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin pulvinar odio in magna condimentum, et euismod ante rhoncus. Maecenas elementum metus quis dolor convallis convallis.",
  },
  {
    title: "GIVE FEEDBACK",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin pulvinar odio in magna condimentum, et euismod ante rhoncus. Maecenas elementum metus quis dolor convallis convallis.",
  },
];
